module.exports = __webpack_public_path__ + "static/millamoolah-3f2afc5718adfbe171218adf266b8f81.png";